module.exports = {
	"PAGE_WIDTH": 365,
	"PAGE_HEIGHT": 575
}